<template lang="pug">
.EquipeForm.row.ae.wp.js
  .col
    label Nome
    input(placeholder="Nome" v-model="form.nome" required)
  .col
    label E-mail
    input(placeholder="E-mail" v-model="form.email")
  .col
    label CPF
    input(placeholder="cpf" v-mask="'###.###.###-##'" v-model="form.cpf" required)
  .col
    label RG
    input(placeholder="rg" v-model="form.rg" required)
  .row
    Button(v-if="form.nome && form.cpf && form.rg" @click="save" layout="green-go" :loader="loader" type="button") {{form.id?'ATUALIZAR':'CADASTRAR'}}
    Button(v-if="form.id && form.status=='ativo'" @click="inactiveAggregate()" :layout="form.status=='ativo'?'red-go':'green-go'" style="margin-left:12px" type="button") {{form.status=='ativo'?'DESATIVAR':'ATIVAR'}}
    //Button(v-if="form.id" @click="form.status=='ativo'?inactiveAggregate():activateAggregate()" :layout="form.status=='ativo'?'red-go':'green-go'" style="margin-left:12px" type="button") {{form.status=='ativo'?'DESATIVAR':'ATIVAR'}}
</template>

<script>
import Vue from 'vue'
import { mapActions } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader.vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
import format from "@/utils/format";
export default {
  name: "EquipeForm",
  props: { f: Object, reload: Function },
  components: { Button, Loader },
  data() {
    return {
      loader: false,
      form: this.f
    };
  },
  methods: {
    ...mapActions("admin", ["EQUIPE_ADMIN_NOVO", "DEL_AGGREGATE_SUPPORTER", "UPDATE_SUPPORTER", "ACTIVATE_AGGREGATE"]),
    async save() {
      this.loader = true;
      let p = { ...this.form }
      p.cpf = format.clear(p.cpf);
      if (this.form.id) await this.UPDATE_SUPPORTER(p)
      else await this.EQUIPE_ADMIN_NOVO(p);
      if (this.reload) this.reload();
      this.loader = false;
    },
    inactiveAggregate() {
      if (confirm("Deseja mesmo desativar este técnico?")) {
        this.DEL_AGGREGATE_SUPPORTER({
          id: this.form.id,
          del: true,
          notRedirect: true
        }).then((r) => {
          if (r.status == 200 || r.status == 201) {
            if(this.reload) this.reload();
          }
        });
      }
    },
    activateAggregate() {
      this.ACTIVATE_AGGREGATE(this.form.id).then((r) => {
        if (r.status == 200 || r.status == 201) {
          if(this.reload) this.reload();
        }
      });
    },
  }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.EquipeForm
  @include card
  label
    @include label
</style>